module.exports = __webpack_public_path__ + "img/레인저.818b9ec9.png";